import { simple } from 'src/utils/reducers';

import * as addBet from './reducers/add-bet';
import * as addLeg from './reducers/add-leg';
import * as addSplitBet from './reducers/add-split-bet';
import * as removeSplitBet from './reducers/remove-split-bet';
import * as updateBet from './reducers/update-bet';
import * as updateLeg from './reducers/update-leg';
import * as removeBet from './reducers/remove-bet';
import * as removeLeg from './reducers/remove-leg';
import * as getPossibleBets from './reducers/get-possible-bets';
import * as placeBet from './reducers/place-bet';
import * as getReferredBetslip from './reducers/get-referred-betslip';
import * as assignReferredBetslip from './reducers/assign-referred-betslip';
import * as acceptReferredBetslip from './reducers/accept-referred-betslip';
import * as offerReferredBetslip from './reducers/offer-referred-betslip';
import * as rejectReferredBetslip from './reducers/reject-referred-betslip';
import * as addMultiple from './reducers/add-multiple';
import * as removeMultiple from './reducers/remove-multiple';
import * as updateBetSlip from './reducers/update-betslip';

// eslint-disable-next-line import/no-default-export
export default simple({
    BETSLIP_ADD_BET: addBet.request,
    BETSLIP_ADD_LEG: addLeg.request,
    BETSLIP_ADD_SPLIT_BET: addSplitBet.request,
    BETSLIP_REMOVE_SPLIT_BET: removeSplitBet.request,
    BETSLIP_UPDATE_BET: updateBet.request,
    BETSLIP_UPDATE_LEG: updateLeg.request,
    BETSLIP_BULK_UPDATE_LEG: updateLeg.bulkUpdate,
    BETSLIP_REMOVE_BET: removeBet.request,
    BETSLIP_REMOVE_LEG: removeLeg.request,

    BETSLIP_GET_POSSIBLE_BETS_REQUEST: getPossibleBets.request,
    BETSLIP_GET_POSSIBLE_BETS_ERROR: getPossibleBets.error,
    BETSLIP_GET_POSSIBLE_BETS_FINISH: getPossibleBets.finish,

    BETSLIP_GET_REFERRED_REQUEST: getReferredBetslip.request,
    BETSLIP_GET_REFERRED_FINISH: getReferredBetslip.finish,
    BETSLIP_GET_REFERRED_ERROR: getReferredBetslip.error,
    BETSLIP_GET_REFERRED_CLEAR: getReferredBetslip.clear,

    BETSLIP_OFFER_REFERRED_REQUEST: offerReferredBetslip.request,
    BETSLIP_OFFER_REFERRED_FINISH: offerReferredBetslip.finish,
    BETSLIP_OFFER_REFERRED_ERROR: offerReferredBetslip.error,
    BETSLIP_OFFER_REFERRED_CLEAR: offerReferredBetslip.clear,

    BETSLIP_PLACE_BET_REQUEST: placeBet.request,
    BETSLIP_PLACE_BET_ERROR: placeBet.error,
    BETSLIP_PLACE_BET_FINISH: placeBet.finish,
    BETSLIP_PLACE_BET_CLEAR: placeBet.clear,

    BETSLIP_ASSIGN_REFERRED_REQUEST: assignReferredBetslip.request,
    BETSLIP_ASSIGN_REFERRED_ERROR: assignReferredBetslip.error,
    BETSLIP_ASSIGN_REFERRED_FINISH: assignReferredBetslip.finish,
    BETSLIP_ASSIGN_REFERRED_CLEAR: assignReferredBetslip.clear,

    BETSLIP_ACCEPT_REFERRED_REQUEST: acceptReferredBetslip.request,
    BETSLIP_ACCEPT_REFERRED_ERROR: acceptReferredBetslip.error,
    BETSLIP_ACCEPT_REFERRED_FINISH: acceptReferredBetslip.finish,
    BETSLIP_ACCEPT_REFERRED_CLEAR: acceptReferredBetslip.clear,

    BETSLIP_REJECT_REFERRED_REQUEST: rejectReferredBetslip.request,
    BETSLIP_REJECT_REFERRED_ERROR: rejectReferredBetslip.error,
    BETSLIP_REJECT_REFERRED_FINISH: rejectReferredBetslip.finish,
    BETSLIP_REJECT_REFERRED_CLEAR: rejectReferredBetslip.clear,

    BETSLIP_ADD_MULTIPLE: addMultiple.request,
    BETSLIP_CLEAR_MULTIPLE: addMultiple.clear,

    BETSLIP_REMOVE_MULTIPLE: removeMultiple.request,

    BETSLIP_UPDATED: updateBetSlip.request,
});
